import { render, staticRenderFns } from "./PedidosCompraForm.vue?vue&type=template&id=ea31d976&scoped=true&"
import script from "./PedidosCompraForm.vue?vue&type=script&lang=js&"
export * from "./PedidosCompraForm.vue?vue&type=script&lang=js&"
import style0 from "./PedidosCompraForm.vue?vue&type=style&index=0&id=ea31d976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea31d976",
  null
  
)

export default component.exports